import { IconArrowNarrowRight } from "@tabler/icons-react";
import Link, { type LinkProps } from "next/link";
import type { HTMLProps } from "react";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type ButtonArrowProps = LinkProps & HTMLProps<HTMLAnchorElement>;

export const ButtonArrow = (props: ButtonArrowProps) => {
  return (
    <Link
      {...props}
      className={cn(
        buttonVariants({ variant: "secondary", size: "lg" }),
        "h-14 rounded-lg px-8 font-medium",
        props.className
      )}
    >
      <span>{props.children}</span>
      <IconArrowNarrowRight className="ml-2" stroke={1.25} />
    </Link>
  );
};
